import {
  Component,
  ViewEncapsulation
}                                from '@angular/core';
import { UserService }           from '../../core/services/user.service';
import { WishListService }       from '../../core/services/wish-list.service';
import { CartService }           from '../../core/services/cart.service';
import { AuthenticationService } from '../../core/services/authentication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {
  constructor (
    private userService: UserService,
    private wishList: WishListService,
    private cart: CartService,
    private authService: AuthenticationService
  ) {}

  isLoggedIn () {
    return this.authService.isAuthenticated();
  }

  getCartScore () {
    return this.cart.getCartScore();
  }

  getWishScore () {
    return this.wishList.countItemsInWishList();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/moddules/header/header.component.ts